__turbopack_context__.v({
  "cardContent": "style-module-scss-module__oE4IDG__cardContent",
  "cardIcon": "style-module-scss-module__oE4IDG__cardIcon",
  "cardStats": "style-module-scss-module__oE4IDG__cardStats",
  "cardTitle": "style-module-scss-module__oE4IDG__cardTitle",
  "component": "style-module-scss-module__oE4IDG__component",
  "condoCard": "style-module-scss-module__oE4IDG__condoCard",
  "headerRow": "style-module-scss-module__oE4IDG__headerRow",
  "heading": "style-module-scss-module__oE4IDG__heading",
  "houseCard": "style-module-scss-module__oE4IDG__houseCard",
  "propertyCard": "style-module-scss-module__oE4IDG__propertyCard",
  "propertyGrid": "style-module-scss-module__oE4IDG__propertyGrid",
  "rentalCard": "style-module-scss-module__oE4IDG__rentalCard",
  "statItem": "style-module-scss-module__oE4IDG__statItem",
  "statLabel": "style-module-scss-module__oE4IDG__statLabel",
  "statValue": "style-module-scss-module__oE4IDG__statValue",
  "totalCount": "style-module-scss-module__oE4IDG__totalCount",
  "townhouseCard": "style-module-scss-module__oE4IDG__townhouseCard",
});
